const SVG = ({ fill = 'none', width = '38', height = '38', viewBox = '0 0 38 38' }) => (
  <svg
    width={width}
    height={height}
    viewBox={viewBox}
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M18.9531 2C9.58734 2 2 9.58844 2 18.9531C2 28.3178 9.58844 35.9062 18.9531 35.9062C28.3189 35.9062 35.9062 28.3178 35.9062 18.9531C35.9062 9.58844 28.3178 2 18.9531 2ZM27.2798 13.6145L24.4973 26.7264C24.2917 27.6561 23.7383 27.8814 22.9661 27.4439L18.7278 24.3202L16.6836 26.2889C16.4583 26.5142 16.2669 26.7056 15.8294 26.7056L16.1302 22.3919L23.9844 15.2956C24.3267 14.9948 23.9089 14.8242 23.4572 15.125L13.7502 21.2358L9.56656 19.9298C8.65766 19.6433 8.63687 19.0209 9.75797 18.5834L26.103 12.2802C26.862 12.0067 27.5248 12.465 27.2787 13.6134L27.2798 13.6145Z" fill="#3C8BDE"/>
  </svg>
)

export default SVG
